/* eslint-disable no-undef */
// import { lock, unlock } from 'tua-body-scroll-lock'

// Follow the Water support
const waterTime = () => gsap.timeline()
  .to(
    '.followWaterContainer > span',
    {
      top: 100,
      duration: 0.6,
      ease: Back.easeInOut.config(1.7),
    },
  )
  .to(
    '.followWaterContainer',
    {
      left: '50%',
      ease: 'power2.inOut',
    },
    '<',
  )
  .from(
    '#water2 .supportingText',
    {
      autoAlpha: 0,
    },
    '<',
  )
  .to( // move the strawberry to the lower right corner
    '#strawberry-container',
    {
      rotate: -23,
      top: '97%',
      left: '95%',
      duration: 4.2,
      ease: 'elastic.inOut(1, 1)',
    },
    '<',
  )
  .from(
    '#water2 .supportingList li',
    {
      autoAlpha: 0,
      x: 10,
      duration: 0.4,
      stagger: 0.1,
    },
    '<',
  )
export default waterTime
